import { Component, createElement } from 'react';
import { connect } from 'react-redux';
import { OptimusPlainLink } from '@mews-commander/ui';
import { openInBrowserTab } from '@mews-commander/utils';
import { trackEvent } from '../../../../../middleware/createAnalyticsMiddleware';
import { navigateInModal } from '../../../../../modules/app/actions/common';
import { LinkAction as LinkActionType } from './types';

interface Props {
    action?: LinkActionType;
    close?: () => void;
    navigateInModal?: (url: string) => void;
}

class LinkAction extends Component<Props> {
    handleClick = () => {
        // @ts-expect-error $TSFixMeError: Property 'target' does not exist on type '{ text?: ReactNode; icon?: ReactNode; url?: ReactNode; target?: ReactNode; } |...
        const { target, url, onClick, disabled } = this.props.action;

        if (disabled) return;

        if (this.props.close) {
            this.props.close();
        }

        if (target) {
            openInBrowserTab(url);
            (this.props as $TSFixMe).trackEvent({
                eventCategory: 'Help',
                eventAction: 'link clicked',
                eventLabel: url,
            });
        } else if (onClick) {
            onClick();
        } else {
            // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
            this.props.navigateInModal(url);
        }
    };

    render() {
        // @ts-expect-error $TSFixMeError: Property 'component' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
        const { action, component } = this.props;

        if (!action) {
            return null;
        }

        const { icon, text, url, disabled, target, dataTestId } = action;

        if (url) {
            return (
                <OptimusPlainLink
                    target={target}
                    underline={false}
                    onClick={this.handleClick}
                    // @ts-expect-error
                    dataTestId={dataTestId}
                    disabled={disabled}
                    {...(disabled ? { as: 'span' } : { href: url })}
                >
                    {createElement(component, {
                        title: text,
                        icon,
                        disabled,
                    })}
                </OptimusPlainLink>
            );
        }

        return createElement(component, {
            title: text,
            icon,
            onClick: this.handleClick,
            'data-test-id': dataTestId,
        });
    }
}

export default connect(undefined, {
    navigateInModal,
    trackEvent,
})(LinkAction);
